import {defineStore} from 'pinia'
import {nextTick} from "vue";
import {setLocalStorage, getLocalStorage} from "@js/helpers.ts";
import {useThemeStore} from "@js/store/ThemeStore.js";
import {checkDocument} from "@js/helpers.ts";

export const useSearchStore = defineStore('searchStore', {
    state: () => ({
        query: '',
        show: false,
        resultsLoaded: true,
        history: getLocalStorage('history_search') ? JSON.parse(getLocalStorage('history_search')) : [],
        results: [],
        getSearchTimeout: null,
        placeholderOptions: [
            "Арматура",
            "Труба профильная",
            "Винтовая свая",
            "Профнастил",
            "Труба электросварная",
            "Балка двутавровая",
            "Уголок металлический",
            "Швеллер",
            "Квадрат",
            "Листовой прокат",
            "Полоса стальная"
        ],
        currentPlaceholder: '',
        optionIndex: 0,
        charIndex: 0,
        typing: true,
        placeholderTypingMounted: false,
    }),

    getters: {
        filteredResults: (state) => {
            if (!state.query) return []
            return state.results.filter(r =>
                r.title.toLowerCase().includes(state.query.toLowerCase())
            )
        }
    },

    actions: {
        showDropdown() {
            this.show = true
            nextTick()
        },
        clearQuery() {
            this.query = ''
            this.results = []
        },
        repeatHistory(value) {
            this.query = value
            this.initSearch()
        },
        addToHistoryCache() {
            if (this.query === null || this.query === '') return;

            const key = 'history_search'
            let history = []

            try {
                const raw = getLocalStorage(key)
                if (raw) {
                    history = JSON.parse(raw)
                }
            } catch (e) {
                history = []
            }

            // Удаляем дубликаты, добавляем в начало
            history = history.filter(item => item !== this.query)
            history.unshift(this.query)

            // Обрезаем до 3-х
            history = history.slice(0, 3)

            setLocalStorage(key, JSON.stringify(history), 43200) // На месяц
            this.history = history
        },
        removeFromHistory(value) {
            const key = 'history_search'
            this.history = this.history.filter(item => item !== value)
            setLocalStorage(key, JSON.stringify(this.history), 43200) //На месяц
        },
        initSearch() {
            this.addToHistoryCache()
        },
        getSearchData() {
            clearTimeout(this.getSearchTimeout);
            this.getSearchTimeout = setTimeout(() => {
                this.results = []
                if (this.query === null || this.query === '') {
                    return
                }
                this.addToHistoryCache()

                if (checkDocument()) {
                    window.scrollTo({top: 0, behavior: 'smooth'}) // Скролл наверх
                }

                this.resultsLoaded = false
                axios.post('/axios/products/text-search', {
                    text: this.query,
                }).then(response => {
                    this.results = response.data
                    this.resultsLoaded = true
                }).catch(error => {
                    this.resultsLoaded = true
                })
            }, 500);
        },
        startTypewriterEffect() {
            if(this.placeholderTypingMounted) return

            this.placeholderTypingMounted = true

            const type = () => {
                const currentWord = this.placeholderOptions[this.optionIndex]

                if (this.typing) {
                    if (this.charIndex < currentWord.length) {
                        this.currentPlaceholder += currentWord[this.charIndex]
                        this.charIndex++
                    } else {
                        this.typing = false
                        setTimeout(type, 2000)
                        return
                    }
                } else {
                    if (this.charIndex > 0) {
                        this.currentPlaceholder = this.currentPlaceholder.slice(0, -1)
                        this.charIndex--
                    } else {
                        this.typing = true
                        this.optionIndex = (this.optionIndex + 1) % this.placeholderOptions.length
                    }
                }

                setTimeout(type, this.typing ? 100 : 50)
            }

            type()
        },
    }
})
